import React, { FC } from 'react';
import styles from './ButtonNoHtmlatt.module.css';

interface ButtonProps {
  onClick: () => void;
  label: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
  active?: boolean;
}

const ButtonNoHtmlatt: FC<ButtonProps> = ({
  onClick,
  label,
  type = 'button',
  disabled = false,
  active = false,
  className,
}) => {
  return (
    <button
      className={`${styles.button} ${active ? styles.active : ''} ${className}`}
      onClick={onClick}
      type={type}
      disabled={disabled}
    >
      <span>{label} </span>
    </button>
  );
};

export default ButtonNoHtmlatt;
